import React, { Component } from 'react';
import styled from 'styled-components';

import ProgressBar from '../../components/ProgressBar';

export default class StoreSection extends Component {
  render() {
    const {
      name,
      address,
      progress,
      completeContractToken,
    } = this.props;

    const combinedAddress = (address && [
      address.name,
      address.number,
      address.street1,
      address.street2,
      address.suburb,
      address.state,
      address.postcode,
      address.state,
      address.country,
    ].filter(v => !!v).join(', ').substring(0, 30)) || [];

    return (
      <Container onClick={() => {
        /* eslint-disable-next-line */
        window.amplitude.getInstance().logEvent('Select Store Click');

        return window.location.replace(`/signup-overview?completeContractToken=${completeContractToken}`);
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'row', width: 250, alignItems: 'center', width: 275, marginRight: 25, justifyContent: 'space-between' }}>
              <div>{name}</div>
              { combinedAddress.length > 0 ? <div>{combinedAddress}</div> : null }
            </div>
            <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '-10px' }}>
              <ProgressBar
                backgroundColor="#37b8ca"
                progress={progress}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: 200, alignItems: 'center', paddingLeft: 20 }}>
              <div>
                {progress}% COMPLETE
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 70px;
  border: 2px solid #e5e5e5;
  border-radius: 0.25em;
  padding: 0.7em 1em;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Account/StoreSection/index.js